export var SideBar = {
  Left: 'left',
  Right: 'right'
};